// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"ee9c5925","203":"d346ecdd","871":"ee9c5925"}[chunkId] + ".chunk.css";
};